<div class="reward-card">
  <h4 class="day-title">{{ title }}</h4>
  <div class="rewards-grid">
    <div *ngFor="let reward of rewards" class="internal-card">
      <div class="thumb-area">
        <img *ngIf="getRewardImage(reward)"
             [src]="getRewardImage(reward)"
             alt="Reward Thumbnail"
             class="item-thumbnail">
        <div *ngIf="!getRewardImage(reward)" class="thumb-placeholder" [ngClass]="getTypeBadgeClass(reward.lineItemType)">
          <i [class]="getTypeIcon(reward.lineItemType)" class="placeholder-icon"></i>
        </div>
      </div>
      <div class="reward-info">
        <span class="type-badge" [ngClass]="getTypeBadgeClass(reward.lineItemType)">
          {{ reward.lineItemType }}
        </span>
        <p class="reward-name" [title]="reward.id?.name">{{ reward.id?.name || '—' }}</p>
        <a *ngIf="reward.id?.id != null" [href]="getLink(reward)" target="_blank" class="item-id">
          #{{ reward.id?.id }}
        </a>
        <span class="quantity-pill">x{{ reward.c }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="!rewards?.length" class="empty-state">
    <i class="pi pi-inbox"></i>
    <span>No rewards</span>
  </div>
</div>
